export default __webpack_public_path__ + "img/app-page/Back.02a9814cd46297eb1d5bb3422ac3f476.png";